import apiClient from './client';

/**
 * Releases the current login session (sign out).
 */
export async function writeLoginRelease(): Promise<void> {
  await apiClient.post('/secure/login/release');
}
